import { client } from '../client';
import { urls } from '../endpoints';
import {
  ApiResponse,
  CreateUserByAdminType,
  GridResponse,
  UserCreateType,
  UserProfileType,
  UserSearchParams,
  UserType,
} from '../../types/types';

export const searchUsersRequest = async (params?: UserSearchParams) => {
  try {
    const response = await client.get<ApiResponse<GridResponse<UserType[]>>>(
      urls.searchUsers(params),
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error searching users:', error);
    return null;
  }
};

export const getUserByIdRequest = async (userId: number) => {
  try {
    const response = await client.get<ApiResponse<UserProfileType>>(
      urls.getUserById(userId),
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching user by ID:', error);
    return null;
  }
};

export const createUserRequest = async (userData: UserCreateType) => {
  try {
    const response = await client.post<ApiResponse<UserType>>(
      urls.createUser,
      userData,
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error creating user:', error);
    return null;
  }
};

export const updateUserRequest = async (userId: number, userData: UserCreateType) => {
  try {
    const response = await client.put<ApiResponse<number>>(     
      urls.updateUser(userId),
      userData,
    );
    if (response.status === 200) {
    return response.data;
    }
    return null;
  }catch (error) {
    console.error('Error updating user:', error);
    return null;
  }   
};

export const createUserAdminRequest = async (userData: CreateUserByAdminType) => {
  try {
    const response = await client.post<ApiResponse<UserType>>(
      urls.createUserAdmin,
      userData,
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error creating user by admin:', error);
    throw error;
  }
};

export const updateUserAdminRequest = async (userId: number, userData: CreateUserByAdminType) => {
  try {
    const response = await client.put<ApiResponse<number>>(     
      urls.updateUserAdmin(userId),
      userData,
    );
    if (response.status === 200) {
    return response.data;
    }
    return null;
  }catch (error) {
    console.error('Error updating user by admin:', error);
    throw error;
  }
};

export const deleteUserRequest = async (userId: number) => {
  try {
    const response = await client.delete<ApiResponse<number>>(
      urls.deleteUser(userId),
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};